(function () {
    'use strict';

    const section = document.querySelector('.sk-machine-search-results');
    if (!section) return;

    const apiUrl = section.dataset.machineSearchApi;
    if (!apiUrl) return;

    const skConfig = (window.SK && window.SK.machineSearch) || {};
    const configPageSize = parseInt(section.dataset.pageSize, 10) || skConfig.pageSize || 24;
    const productCfg = skConfig.productCard || {};
    const categoryCfg = skConfig.categoryCard || {};

    const headingEl = section.querySelector('[data-machine-search-heading]');
    const controlsEl = section.querySelector('[data-machine-search-controls]');
    const scopeToggle = section.querySelector('[data-machine-search-controls] .sk-search-scope-toggle');
    const filterLabel = section.querySelector('[data-machine-search-filter-label]');
    const filterName = section.querySelector('[data-machine-search-filter-name]');
    const bodyEl = section.querySelector('[data-machine-search-body]');
    const countEl = section.querySelector('[data-machine-search-count]');
    const listEl = section.querySelector('[data-machine-search-list]');
    const loadMoreLoadingEl = section.querySelector('[data-machine-search-load-more-loading]');
    const paginationEl = section.querySelector('[data-machine-search-pagination]');
    const emptyEl = section.querySelector('[data-machine-search-empty]');
    const errorEl = section.querySelector('[data-machine-search-error]');
    const categoriesSectionEl = section.querySelector('[data-machine-search-categories-section]');
    const categoriesListEl = section.querySelector('[data-machine-search-categories-list]');
    const categoriesLoadingEl = section.querySelector('[data-machine-search-categories-loading]');
    const productsLoadingEl = section.querySelector('[data-machine-search-products-loading]');
    const noProductsEl = section.querySelector('[data-machine-search-no-products]');
    const productContainerEl = listEl ? listEl.closest('.product-grid-container') : null;
    const placeholderSvg = (function () {
        const raw = skConfig.categoryPlaceholderSvg || '';
        return raw ? raw.replace('<svg ', '<svg class="placeholder-svg" ') : '';
    }());

    let originalCollection = '';
    let currentScope = 'all';
    let currentCollection = '';

    let activeAbort = null;
    let activeQuery = '';
    let activeCollection = '';

    let pageSize = configPageSize;
    let totalCount = 0;
    let currentPage = 1;

    function escapeHtml(str) {
        if (!str) return '';
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function buildImgHtml(src, alt, aspectRatio, sizingRule, imgSizes) {
        const ar = aspectRatio || 'natural';
        const sr = sizingRule || 'cover';
        if (!src) {
            return '<figure class="media ' + sr + ' ' + ar + ' media--empty">' +
                '<svg viewBox="0 0 525 525" class="placeholder-svg" preserveAspectRatio="xMidYMid slice" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="525" height="525" fill="#D4D4D4"/><path d="M263 162C221.684 162 188 195.684 188 237C188 278.316 221.684 312 263 312C304.316 312 338 278.316 338 237C338 195.684 304.316 162 263 162Z" fill="#C4C4C4"/></svg>' +
                '</figure>';
        }
        const sep = src.indexOf('?') > -1 ? '&' : '?';
        if (imgSizes) {
            const src200 = src + sep + 'width=200';
            const src400 = src + sep + 'width=400';
            const src600 = src + sep + 'width=600';
            return '<figure class="media ' + sr + ' ' + ar + '">' +
                '<img src="' + escapeHtml(src400) + '"' +
                ' srcset="' + escapeHtml(src200) + ' 200w, ' + escapeHtml(src400) + ' 400w, ' + escapeHtml(src600) + ' 600w"' +
                ' sizes="' + escapeHtml(imgSizes) + '"' +
                ' alt="' + escapeHtml(alt || '') + '"' +
                ' loading="lazy" width="400" height="400">' +
                '</figure>';
        }
        const srcSmall = src + sep + 'width=120';
        const srcMedium = src + sep + 'width=200';
        return '<figure class="media ' + sr + ' ' + ar + '">' +
            '<img src="' + escapeHtml(srcMedium) + '"' +
            ' srcset="' + escapeHtml(srcSmall) + ' 120w, ' + escapeHtml(srcMedium) + ' 200w"' +
            ' sizes="96px"' +
            ' alt="' + escapeHtml(alt || '') + '"' +
            ' loading="lazy" width="96" height="96">' +
            '</figure>';
    }

    function buildMetafieldsHtml(metafields, metafieldLabels) {
        const keys = Object.keys(metafields || {});
        if (!keys.length) return '';
        const excludeKeys = (window.SK && window.SK.productAttributesExcludeKeys) || [];
        let items = '';
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const value = metafields[key];
            const strVal = String(value);
            if (strVal.trim().charAt(0) === '[') continue; // skip JSON arrays (e.g. related products GIDs)
            const bareKey = key.split('.').pop();
            if (excludeKeys.indexOf(bareKey) !== -1) continue;
            const i18nMf = window.SK && window.SK.i18n && window.SK.i18n.productMetafields;
            const label = (i18nMf && i18nMf[bareKey]) ||
                (metafieldLabels && metafieldLabels[key]) ||
                bareKey.replace(/_/g, ' ');
            items += '<div class="product-metafields-list__item">' +
                '<span class="product-metafields-list__label">' + escapeHtml(label) + ':</span>' +
                '<span class="product-metafields-list__value">' + escapeHtml(strVal) + '</span>' +
                '</div>';
        }
        if (!items) return '';
        return '<div class="card-center"><div class="product-metafields-list">' + items + '</div></div>';
    }

    function isConfigurableProduct(metafields) {
        const keys = Object.keys(metafields || {});
        for (let i = 0; i < keys.length; i++) {
            const strVal = String(metafields[keys[i]]).trim();
            if (strVal.charAt(0) === '[' && strVal.indexOf('gid://shopify/Metaobject/') !== -1) {
                return true;
            }
        }
        return false;
    }

    function buildProductCard(product) {
        const handle = product.handle || '';
        const url = product.url    || ('/products/' + handle);
        const title = product.title || '';
        const imgUrl = (product.featuredImage && product.featuredImage.url) || '';
        const imgAlt = (product.featuredImage && product.featuredImage.altText) || title;
        const model = (product.machine && product.machine.model) || '';
        const brand = (product.machine && product.machine.brand) || '';
        const primaryColor = product.collectionPrimaryColor || '';
        const sku = product.partNumber || '';
        const variantId = (product.variantId || '').replace(/^gid:\/\/shopify\/ProductVariant\//, '');
        const metafields = product.metafields || {};
        const metafieldLabels = product.metafieldLabels || {};

        const cardType = productCfg.cardType || 'line';
        const aspectRatio = productCfg.aspectRatio || 'natural';
        const fillRule = productCfg.fillRule || 'cover';
        const imgPadding = productCfg.imagePadding || '0';
        const badgesPos = productCfg.badgesPosition || 'bottom-left';

        const metafieldsHtml = buildMetafieldsHtml(metafields, metafieldLabels);
        const hasCardCenter  = metafieldsHtml !== '';
        const configurable   = isConfigurableProduct(metafields);

        let cardClasses = 'card card--product card--' + escapeHtml(cardType) + ' view--grid';
        if (hasCardCenter) cardClasses += ' has-card-center';

        const safePrimary = /^--[\w-]+$/.test(primaryColor) ? primaryColor : '';
        const cardStyle = safePrimary ? ' style="--current-collection: var(' + safePrimary + ');"' : '';

        let html = '<div class="' + cardClasses + '"' + cardStyle + '>';

        html += '<a href="' + escapeHtml(url) + '" class="full-unstyled-link">' +
            '<span class="visually-hidden">' + escapeHtml(title) + '</span>' +
            '</a>';

        html += '<div class="card-top">';
        html += '<div class="card-media p-' + escapeHtml(String(imgPadding)) + '">';
        if (imgUrl) {
            html += buildImgHtml(imgUrl, imgAlt, aspectRatio, fillRule);
        } else if (placeholderSvg) {
            html += '<figure class="media ' + fillRule + ' ' + aspectRatio + ' media--empty">' + placeholderSvg + '</figure>';
        } else {
            html += buildImgHtml('', imgAlt, aspectRatio, fillRule);
        }
        html += '<div class="card-media-overlay flex ' + escapeHtml(badgesPos) + '"></div>';
        html += '</div>';
        html += '<div class="content">';
        if (sku) {
            html += '<p class="product__sku js">';
            html += '<span class="label">' + escapeHtml((window.SK.i18n && window.SK.i18n.partNumber) || 'Part Number') + ': ' + escapeHtml(sku) + '</span>';
            html += '</p>';
        }
        html += '<h3 class="card-title h5">' + escapeHtml(title) + '</h3>';
        const modelLabel = (window.SK.i18n && window.SK.i18n.machineModel) || '';
        const brandLabel = (window.SK.i18n && window.SK.i18n.brand) || '';
        if (model) {
            html += '<p class="product__machine-model size--tiny">' + (modelLabel ? escapeHtml(modelLabel) + ': ' : '') + escapeHtml(model) + '</p>';
        }
        if (brand) {
            html += '<p class="product__machine-brand size--tiny">' + (brandLabel ? escapeHtml(brandLabel) + ': ' : '') + escapeHtml(brand) + '</p>';
        }
        html += '</div>';
        html += '</div>';

        html += metafieldsHtml;

        if (!configurable) {
            html += '<div class="card-bottom">';
            html += '<div>';
            html += '<quantity-input class="quantity" data-url="/products/' + escapeHtml(handle) + '">';
            html += '<button class="quantity__button no-js-hidden btn btn--with-icon" name="minus" type="button"><svg role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>';
            html += '<input class="quantity__input" type="number" name="quantity" min="1" value="1">';
            html += '<button class="quantity__button no-js-hidden btn btn--with-icon" name="plus" type="button"><svg role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>';
            html += '</quantity-input>';
            html += '</div>';

            html += '<div class="card-body">';
            html += '<div class="product-form__buttons">';
            html += '<button type="button" class="btn btn--primary btn--full quick-buy_link"' +
                (variantId ? ' data-variant-id="' + escapeHtml(String(variantId)) + '"' : '') +
                ' data-product-url="/products/' + escapeHtml(handle) + '">';
            html += '<span>' + escapeHtml((window.variantStrings && window.variantStrings.addToCart) || 'Add to quote') + '</span>';
            html += '</button>';
            html += '</div>';
            html += '</div>';
            html += '</div>';
        }

        html += '</div>';
        return html;
    }

    function buildCategoryCard(collection) {
        const handle = collection.handle || '';
        const title = collection.title || '';
        const url = collection.url || ('/collections/' + handle);
        const imgUrl = collection.imageUrl || '';
        const imgAlt = collection.imageAlt || title;
        const primaryColor = collection.primaryColor || '';
        const safePrimary = /^--[\w-]+$/.test(primaryColor) ? primaryColor : '';
        const cardStyle = safePrimary ? ' style="--current-collection: var(' + safePrimary + ');"' : '';

        const optionsStr = categoryCfg.cardOptions || 'default:default:bottom-left';
        const parts = optionsStr.split(':');
        const cardType = parts[0] || 'default';
        const cardLayout = parts[1] || 'default';
        const overlayPos = parts[2] || 'bottom-left';
        const textAlign = categoryCfg.textAlign || '';
        const showIcon = categoryCfg.showLinkIcon !== false;
        const showLabelPrimary = categoryCfg.showLabelPrimary;
        const aspectRatio = categoryCfg.aspectRatio || 'natural';
        const cardView = categoryCfg.cardView || 'subcategory';

        const iconHtml = showIcon
            ? '<button class="btn btn--primary btn--inline link-icon">' +
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<g clip-path="url(#clip0_279_8596)">' +
            '<path d="M16.0044 9.414L7.3974 18.021L5.9834 16.607L14.5894 8H7.0044V6H18.0044V17H16.0044V9.414Z" fill="currentColor"></path>' +
            '</g>' +
            '</svg>' +
            '</button>'
            : '';

        let html;

        if (cardView === 'subcategory') {
            html = '<a class="card card--collection card--' + escapeHtml(cardType) + ' bg-solid ' +
                escapeHtml(textAlign) + ' view--search"' +
                cardStyle +
                ' href="' + escapeHtml(url) + '">';
            html += '<div class="card-media">';
            if (imgUrl) {
                html += buildImgHtml(imgUrl, imgAlt, 'natural', 'contain', '(max-width: 640px) 45vw, (max-width: 768px) 22vw, 18vw');
            } else {
                html += '<figure class="media contain natural media--empty">' + placeholderSvg + '</figure>';
            }
            html += '</div>';
            html += '<div class="card-body">';
            html += '<h3 class="title' + (showLabelPrimary ? ' primary' : '') + '"><span class="link-text">' + escapeHtml(title) + '</span></h3>';
            html += iconHtml;
            html += '</div>';
            html += '</a>';
        } else {
            const cardContent = '<h3 class="title flex vertical-center gap-half-gutter" style="flex-wrap:nowrap;">' +
                '<span class="link-text">' + escapeHtml(title) + '</span>' +
                iconHtml + '</h3>';

            html = '<a class="card card--collection card--' + escapeHtml(cardType) + ' bg-solid ' +
                escapeHtml(textAlign) + '"' +
                cardStyle +
                ' href="' + escapeHtml(url) + '">';
            html += '<div class="card-media">';
            html += buildImgHtml(imgUrl, imgAlt, aspectRatio, 'cover');
            if (cardLayout === 'overlay') {
                html += '<div class="card-media-overlay flex ' + escapeHtml(overlayPos) + '">' + cardContent + '</div>';
            }
            html += '</div>';
            if (cardLayout === 'default') {
                html += '<div class="card-body">' + cardContent + '</div>';
            }
            html += '</a>';
        }

        return html;
    }

    function appendCards(container, htmlStrings) {
        const fragment = document.createDocumentFragment();
        htmlStrings.forEach(function (html) {
            if (!html || !html.trim()) return;
            const temp = document.createElement('div');
            temp.innerHTML = html.trim();
            while (temp.firstChild) {
                fragment.appendChild(temp.firstChild);
            }
        });
        container.appendChild(fragment);
    }

    function makeSvgIcon(points) {
        const ns = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('role', 'presentation');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('xmlns', ns);
        svg.setAttribute('width', '20');
        svg.setAttribute('height', '20');
        svg.setAttribute('viewBox', '0 0 20 20');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
        svg.setAttribute('stroke-width', '2');
        svg.setAttribute('stroke-linecap', 'round');
        svg.setAttribute('stroke-linejoin', 'round');
        const poly = document.createElementNS(ns, 'polyline');
        poly.setAttribute('points', points);
        svg.appendChild(poly);
        return svg;
    }

    function pageToAfterCursor(pageNum, ps) {
        if (pageNum <= 1) return null;
        return btoa('offset:' + ((pageNum - 1) * ps - 1));
    }

    function buildPageUrl(q, coll, page) {
        const sp = new URLSearchParams();
        if (q) sp.set('query', q);
        if (coll) sp.set('collection', coll);
        if (page > 1) sp.set('page', String(page));
        sp.set('limit', String(pageSize));
        const qs = sp.toString();
        return window.location.pathname + (qs ? '?' + qs : '');
    }

    function buildPageParts(current, total) {
        if (total <= 1) return [];
        const visible = {};
        [1, total, current - 1, current, current + 1].forEach(function (n) {
            if (n >= 1 && n <= total) visible[n] = true;
        });
        const nums = Object.keys(visible).map(Number).sort(function (a, b) {
            return a - b;
        });
        const parts = [];
        for (let i = 0; i < nums.length; i++) {
            if (i > 0 && nums[i] - nums[i - 1] > 1) parts.push(null); // null = ellipsis
            parts.push(nums[i]);
        }
        return parts;
    }

    function makePaginationLink(href, classes, label, child) {
        const el = document.createElement('a');
        el.href = href;
        el.className = classes;
        if (label) el.setAttribute('aria-label', label);
        if (child) el.appendChild(child);
        return el;
    }

    function makePaginationSpan(classes, text, isCurrent) {
        const el = document.createElement('span');
        el.className = classes;
        if (isCurrent) el.setAttribute('aria-current', 'page');
        const inner = document.createElement('span');
        inner.textContent = text;
        el.appendChild(inner);
        return el;
    }

    function renderPagination(q, coll, page, total, ps) {
        if (!paginationEl) return;
        const totalPages = Math.ceil(total / ps);

        if (totalPages <= 1) {
            setVisible(paginationEl, false);
            return;
        }

        const nav = document.createElement('nav');
        nav.className = 'pagination' + (totalPages > 5 ? ' wide-parts' : '') + ' size--tiny';
        nav.setAttribute('role', 'navigation');
        nav.setAttribute('aria-label', (window.SK.i18n && window.SK.i18n.paginationLabel) || 'Pagination');

        if (page > 1) {
            const prevLink = makePaginationLink(
                buildPageUrl(q, coll, page - 1),
                'pagination-item arrow-link arrow-link--prev btn btn--secondary',
                (window.SK.i18n && window.SK.i18n.paginationPrevious) || 'Previous page',
                makeSvgIcon('12 6 8 10 12 14')
            );
            nav.appendChild(prevLink);
        } else {
            const prevSpan = document.createElement('span');
            prevSpan.className = 'pagination-item arrow-link arrow-link--prev disabled';
            prevSpan.appendChild(makeSvgIcon('12 6 8 10 12 14'));
            nav.appendChild(prevSpan);
        }

        const parts = document.createElement('div');
        parts.className = 'pagination-parts';
        const pageParts = buildPageParts(page, totalPages);
        for (let i = 0; i < pageParts.length; i++) {
            const p = pageParts[i];
            if (p === null) {
                parts.appendChild(makePaginationSpan('pagination-item dot-notation', '...', false));
            } else if (p === page) {
                parts.appendChild(makePaginationSpan('pagination-item current-page', String(p), true));
            } else {
                const pageLink = makePaginationLink(
                    buildPageUrl(q, coll, p),
                    'pagination-item page-link btn btn--secondary',
                    ((window.SK.i18n && window.SK.i18n.paginationPage) || 'Page __NUM__').replace('__NUM__', p),
                    null
                );
                const pageInner = document.createElement('span');
                pageInner.textContent = String(p);
                pageLink.appendChild(pageInner);
                parts.appendChild(pageLink);
            }
        }
        nav.appendChild(parts);

        if (page < totalPages) {
            const nextLink = makePaginationLink(
                buildPageUrl(q, coll, page + 1),
                'pagination-item arrow-link arrow-link--next btn btn--secondary',
                (window.SK.i18n && window.SK.i18n.paginationNext) || 'Next page',
                makeSvgIcon('8 14 12 10 8 6')
            );
            nav.appendChild(nextLink);
        } else {
            const nextSpan = document.createElement('span');
            nextSpan.className = 'pagination-item arrow-link arrow-link--next disabled';
            nextSpan.appendChild(makeSvgIcon('8 14 12 10 8 6'));
            nav.appendChild(nextSpan);
        }

        while (paginationEl.firstChild) paginationEl.removeChild(paginationEl.firstChild);
        paginationEl.appendChild(nav);
        setVisible(paginationEl, true);

        nav.querySelectorAll('a[href]').forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                const targetUrl = new URL(link.href, window.location.href);
                const sp = new URLSearchParams(targetUrl.search);
                const targetPage = Math.max(1, parseInt(sp.get('page') || '1', 10));
                const targetQ = sp.get('query') || '';
                const targetCol = sp.get('collection') || '';
                history.pushState(null, '', link.href);
                currentCollection = targetCol;
                currentScope = targetCol ? 'collection' : 'all';
                updateScopeUI();
                fetchAllResults(targetQ, targetCol, targetPage);
                section.scrollIntoView({behavior: 'smooth', block: 'start'});
            });
        });
    }

    function getParams() {
        const sp = new URLSearchParams(window.location.search);
        const limitVal = parseInt(sp.get('limit') || '0', 10);
        return {
            q: sp.get('query') || sp.get('q') || '',
            collection: sp.get('collection') || '',
            page: Math.max(1, parseInt(sp.get('page') || '1', 10)),
            limit: limitVal > 0 ? Math.min(limitVal, 200) : 0
        };
    }

    function updateUrl(q, coll, page) {
        history.pushState(null, '', buildPageUrl(q, coll, page));
    }

    function setVisible(el, visible) {
        if (!el) return;
        if (visible) {
            el.removeAttribute('hidden');
        } else {
            el.setAttribute('hidden', '');
        }
    }

    function formatCollectionHandle(handle) {
        return handle.replace(/-/g, ' ').replace(/\b\w/g, function (c) {
            return c.toUpperCase();
        });
    }

    function showLoading() {
        setVisible(bodyEl, true);
        setVisible(emptyEl, false);
        setVisible(errorEl, false);
        setVisible(paginationEl, false);
        setVisible(loadMoreLoadingEl, false);
        setVisible(productsLoadingEl, true);
        setVisible(noProductsEl, false);
        setVisible(productContainerEl, true);
        if (listEl) {
            listEl.replaceChildren();
            listEl.classList.remove('is-appearing');
        }
        if (currentPage <= 1) {
            setVisible(categoriesLoadingEl, true);
            if (categoriesListEl) { categoriesListEl.replaceChildren(); }
            if (categoriesSectionEl) setVisible(categoriesSectionEl, false);
        }
        if (countEl) countEl.textContent = '';
    }

    function showEmpty() {
        setVisible(bodyEl, false);
        setVisible(errorEl, false);
        setVisible(emptyEl, true);
        setVisible(paginationEl, false);
        setVisible(categoriesLoadingEl, false);
        setVisible(productsLoadingEl, false);
        setVisible(noProductsEl, false);
    }

    function showError() {
        setVisible(bodyEl, false);
        setVisible(emptyEl, false);
        setVisible(errorEl, true);
        setVisible(paginationEl, false);
        setVisible(categoriesLoadingEl, false);
        setVisible(productsLoadingEl, false);
        setVisible(noProductsEl, false);
    }

    function updateScopeUI() {
        if (!scopeToggle) return;
        scopeToggle.querySelectorAll('[data-scope]').forEach(function (btn) {
            btn.classList.toggle('is-active', btn.dataset.scope === currentScope);
        });
        setVisible(filterLabel, currentScope === 'collection');
    }

    function initScopeToggle() {
        if (!originalCollection || !controlsEl || !scopeToggle) return;
        setVisible(controlsEl, true);
        if (filterName) filterName.textContent = formatCollectionHandle(originalCollection);
        updateScopeUI();
        scopeToggle.addEventListener('click', function (e) {
            const btn = e.target.closest('[data-scope]');
            if (!btn) return;
            const newScope = btn.dataset.scope;
            if (newScope === currentScope) return;
            currentScope = newScope;
            currentCollection = currentScope === 'collection' ? originalCollection : '';
            updateScopeUI();
            const q = getParams().q;
            updateUrl(q, currentCollection, 1);
            fetchAllResults(q, currentCollection, 1);
        });
    }

    function fetchPage(q, coll, after, signal) {
        const url = new URL(apiUrl);
        url.searchParams.set('query', q);
        url.searchParams.set('limit', String(pageSize));
        if (coll) url.searchParams.set('collection', coll);
        if (after) url.searchParams.set('after', after);
        var locale = window.SK && window.SK.locale;
    if (locale) url.searchParams.set('locale', locale);
    return fetch(url.toString(), { signal: signal })
      .then(function (res) {
        if (!res.ok) {
                    return res.text().then(function (body) {
                        throw new Error('API error ' + res.status + ': ' + body.slice(0, 200));
                    });
                }
                return res.json().catch(function (parseErr) {
                    throw new Error('API returned invalid JSON: ' + parseErr.message);
                });
            });
    }

    function updateHeading(q, count) {
        if (!headingEl) return;
        const template = headingEl.dataset.machineSearchHeading || '';
        const qDisplay = q ? (q.charAt(0).toUpperCase() + q.slice(1)) : '';
        const withQuery = template.replace('{query}', qDisplay);
        const parts = withQuery.split('{count}');
        headingEl.replaceChildren();
        parts.forEach(function (part, i) {
            headingEl.appendChild(document.createTextNode(part));
            if (i < parts.length - 1) {
                const span = document.createElement('span');
                span.style.color = 'var(--color-outlines)';
                span.textContent = count !== undefined ? String(count) : '';
                headingEl.appendChild(span);
            }
        });
    }

    function fetchAllResults(q, coll, page) {
        if (!q) return;
        page = page || 1;
        if (activeAbort) activeAbort.abort();
        activeAbort = new AbortController();
        activeQuery = q;
        activeCollection = coll;
        currentPage = page;
        showLoading();

        const after = pageToAfterCursor(page, pageSize);

        fetchPage(q, coll, after, activeAbort.signal)
            .then(function (data) {
                try {
                    const products = data.products || [];
                    const collections = data.collections || [];
                    const total = typeof data.total === 'number' ? data.total : null;

                    if (products.length === 0 && collections.length === 0) {
                        updateHeading(q, 0);
                        showEmpty();
                        return;
                    }

                    if (page === 1 && products.length > 0) {
                        pageSize = products.length > pageSize ? products.length : pageSize;
                    }
                    if (total !== null) totalCount = total;
                    updateHeading(q, total !== null ? total : undefined);

                    setVisible(productsLoadingEl, false);
                    setVisible(categoriesLoadingEl, false);

                    if (categoriesSectionEl) {
                        if (collections.length > 0 && categoriesListEl) {
                            categoriesListEl.replaceChildren();
                            appendCards(categoriesListEl, collections.map(buildCategoryCard));
                            categoriesSectionEl.classList.remove('is-appearing');
                            setVisible(categoriesSectionEl, true);
                            requestAnimationFrame(function () {
                                categoriesSectionEl.classList.add('is-appearing');
                            });
                        } else {
                            setVisible(categoriesSectionEl, false);
                        }
                    }

                    if (listEl) {
                        listEl.replaceChildren();
                        if (products.length > 0) {
                            setVisible(productContainerEl, true);
                            setVisible(listEl, true);
                            setVisible(noProductsEl, false);
                            appendCards(listEl, products.map(buildProductCard));
                            requestAnimationFrame(function () {
                                listEl.classList.add('is-appearing');
                            });
                        } else {
                            setVisible(productContainerEl, false); // hide entire container — categories-only case
                            setVisible(listEl, false);
                            setVisible(noProductsEl, false);  // "both empty" already handled by showEmpty() above
                        }
                    }

                    if (countEl && total !== null) {
                        countEl.textContent = total + ' result' + (total !== 1 ? 's' : '');
                    }

                    if (window.SKAnalytics && products.length > 0) {
                        var ga4List = {
                            list_id: 'machine_search',
                            list_name: q ? ('Machine search: ' + q) : 'Machine search',
                            items: products.map(function (p) {
                                var item = {
                                    item_id: p.partNumber || p.handle || '',
                                    item_name: p.title || '',
                                    url: p.url || ('/products/' + (p.handle || ''))
                                };
                                var model = p.machine && p.machine.model;
                                if (model) item.item_variant = model;
                                return item;
                            })
                        };
                        window.SKAnalytics.viewItemList(ga4List);
                        window.SKAnalytics.registerItemList(ga4List);
                    }

                    if (total !== null) {
                        renderPagination(q, coll, page, total, pageSize);
                    }
                } catch (renderErr) {
                    throw new Error('Render error after fetch: ' + renderErr.message);
                }
            })
            .catch(function (err) {
                if (err && err.name === 'AbortError') return;
                console.error('Machine search failed:', err);
                showError();
            });
    }

    function handleAddToCart(e) {
        const btn = e.target.closest('.quick-buy_link');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();

        const variantId = btn.dataset.variantId;
        if (!variantId) {
            const url = btn.dataset.productUrl;
            if (url) window.location.href = url;
            return;
        }

        const card = btn.closest('.card--product');
        const qtyInput = card && card.querySelector('.quantity__input');
        const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');

        fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            body: JSON.stringify({id: parseInt(variantId, 10), quantity: qty})
        })
            .then(function (res) {
                if (!res.ok) {
                    return res.text().then(function (body) {
                        var msg = 'Error';
                        try {
                            msg = JSON.parse(body).description || msg;
                        } catch (e) { /* non-JSON error body */
                        }
                        throw new Error(msg);
                    });
                }
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            })
            .catch(function (err) {
                console.error('Add to cart:', err);
                alert(err.message || (window.SK.i18n && window.SK.i18n.cartError) || 'Please try again later.');
            })
            .finally(function () {
                btn.removeAttribute('aria-disabled');
                btn.classList.remove('loading');
            });
    }

    const params = getParams();
    if (params.limit) pageSize = params.limit;
    originalCollection = params.collection;
    currentCollection = params.collection;
    currentScope = params.collection ? 'collection' : 'all';

    if (listEl) listEl.addEventListener('click', handleAddToCart);

    initScopeToggle();
    if (params.q) {
        // Queue the search event: this script may run before the deferred
        // sk-ga4.js, which drains SK_GA4_SEARCH once it initializes.
        (window.SK_GA4_SEARCH = window.SK_GA4_SEARCH || []).push(params.q);
        fetchAllResults(params.q, currentCollection, params.page);
    } else updateHeading('', 0);

    window.addEventListener('popstate', function () {
        const p = getParams();
        if (p.limit) pageSize = p.limit;
        currentCollection = p.collection;
        currentScope = currentCollection ? 'collection' : 'all';
        updateScopeUI();
        if (p.q) {
            fetchAllResults(p.q, p.collection, p.page);
        } else {
            if (activeAbort) {
                activeAbort.abort();
                activeAbort = null;
            }
            updateHeading('', 0);
            setVisible(bodyEl, false);
            setVisible(emptyEl, false);
            setVisible(errorEl, false);
            setVisible(paginationEl, false);
            setVisible(loadMoreLoadingEl, false);
            setVisible(categoriesLoadingEl, false);
            setVisible(productsLoadingEl, false);
            setVisible(noProductsEl, false);
            if (listEl) listEl.replaceChildren();
            if (countEl) countEl.textContent = '';
        }
    });

})();
